import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const fetchAccountSettings = async () => {
  const res = await axios.get(`${API}/account/settings`, { headers: getHeaders() });
  return res.data;
};

export const updateAccountProfile = async (payload) => {
  const res = await axios.put(`${API}/account/settings/profile`, payload, { headers: getHeaders() });
  return res.data;
};

export const updateAccountSecurity = async (payload) => {
  const res = await axios.put(`${API}/account/settings/security`, payload, { headers: getHeaders() });
  return res.data;
};

export const updateAccountPrivacy = async (payload) => {
  const res = await axios.put(`${API}/account/settings/privacy`, payload, { headers: getHeaders() });
  return res.data;
};

export const updateAccountNotifications = async (payload) => {
  const res = await axios.put(`${API}/account/settings/notifications`, payload, { headers: getHeaders() });
  return res.data;
};

export const fetchNotificationHistory = async ({ scope, venueAppId } = {}) => {
  const params = {};
  if (scope) params.scope = scope;
  if (venueAppId) params.venue_app_id = venueAppId;
  const headers = getHeaders();
  if (venueAppId) headers['X-Active-Venue-App-Id'] = venueAppId;
  const res = await axios.get(`${API}/notifications/history`, { headers, params });
  return res.data || [];
};

export const deleteMyAccount = async ({ password, confirmation, reason }) => {
  const res = await axios.post(
    `${API}/auth/delete-account`,
    { password, confirmation, reason: reason || null },
    { headers: getHeaders() }
  );
  return res.data;
};

export const cancelMyDeletion = async ({ password }) => {
  const res = await axios.post(
    `${API}/auth/cancel-deletion`,
    { password },
    { headers: getHeaders() }
  );
  return res.data;
};

// GDPR Art. 15 / Art. 20 — Download every record Allure holds about you.
// Streams a JSON blob from the backend and triggers a browser Save dialog.
export const exportMyData = async () => {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API}/account/export-data`, {
    method: 'GET',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) {
    let detail = 'Failed to prepare your data export.';
    try {
      const body = await res.json();
      detail = body.detail || detail;
    } catch (_e) {
      // Non-JSON response — keep generic detail.
    }
    throw new Error(detail);
  }
  const blob = await res.blob();
  // Filename comes from the backend's Content-Disposition header.
  const disposition = res.headers.get('Content-Disposition') || '';
  const match = disposition.match(/filename="?([^"]+)"?/i);
  const filename = match ? match[1] : `allure-data-${Date.now()}.json`;

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  return { filename, size: blob.size };
};

// Sign-in method management (Login & Security card).
export const setMyPassword = async ({ password }) => {
  const res = await axios.post(
    `${API}/auth/set-password`,
    { password },
    { headers: getHeaders() }
  );
  return res.data;
};

export const disconnectGoogle = async () => {
  const res = await axios.post(
    `${API}/auth/google/disconnect`,
    {},
    { headers: getHeaders() }
  );
  return res.data;
};

export const connectGoogle = async ({ accessToken }) => {
  const res = await axios.post(
    `${API}/auth/google/connect`,
    { access_token: accessToken },
    { headers: getHeaders() }
  );
  return res.data;
};